export enum InitiatorType {
    SYSTEM = 'system',
    AUTOMATION = 'auto',
    USER = 'user',
    PUBLIC_USER = 'public',
}